import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { to: "/services", label: "Services", id: "nav-link-services" },
  { to: "/realisations", label: "Réalisations", id: "nav-link-realisations" },
  { to: "/process", label: "Notre process", id: "nav-link-process" },
  { to: "/#faq", label: "FAQ", id: "nav-link-faq" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname, hash]);

  return (
    <header className="sticky top-0 z-50 border-b border-black/5 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-12">
        <Link to="/" data-testid="brand-logo" aria-label="TroiDéo — accueil">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              className={({ isActive }) =>
                l.to.endsWith("#faq")
                  ? "text-sm font-medium text-neutral-600 transition-colors hover:text-ink"
                  : `text-sm font-medium transition-colors hover:text-ink ${
                      isActive ? "text-ink underline decoration-accent decoration-2 underline-offset-8" : "text-neutral-600"
                    }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden items-center gap-2 font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-500 md:flex">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent" />
            </span>
            Ouverture Octobre 2026
          </span>
          <Link
            to="/devis"
            data-testid="nav-cta-estimate-button"
            className="hidden rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-200 hover:scale-[1.03] hover:bg-accent sm:inline-flex"
          >
            Demander un devis
          </Link>
          <button
            type="button"
            data-testid="nav-menu-toggle-button"
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-accent/70 bg-white text-ink transition-colors hover:bg-orange-50 lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="absolute inset-x-4 top-full z-50 mt-1 rounded-2xl border border-accent/50 bg-white p-2 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.25)] lg:hidden"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.id}-mobile`}
              className={({ isActive }) =>
                l.to.endsWith("#faq")
                  ? "block rounded-xl px-4 py-3 text-sm font-medium text-neutral-700 transition-colors hover:bg-orange-50 hover:text-ink"
                  : `block rounded-xl px-4 py-3 text-sm font-medium transition-colors hover:bg-orange-50 hover:text-ink ${
                      isActive ? "bg-orange-50 text-ink" : "text-neutral-700"
                    }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/devis"
            data-testid="nav-link-devis-mobile"
            className="mt-1 block rounded-xl bg-ink px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-accent"
          >
            Demander un devis
          </Link>
        </nav>
      )}
    </header>
  );
}
